/* eslint-disable quotes */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';
import { Map, TileLayer, Marker } from 'react-leaflet';
import moment from 'moment-timezone';
import { translate } from 'react-i18next';
import L from 'leaflet';
import $ from 'jquery';
import { getLocationText } from '../../utils/geo';

const MAX_VOLTAGE = 12600;
const MIN_VOLTAGE = 10500;

const voltageToPercents = voltage => {
  if (voltage >= MAX_VOLTAGE) return 100;
  if (voltage <= MIN_VOLTAGE) return 0;

  return Math.round(
    100 * (voltage - MIN_VOLTAGE) / (MAX_VOLTAGE - MIN_VOLTAGE),
  );
};

const toDegreesMinutesAndSeconds = coordinate => {
  const absolute = Math.abs(coordinate);
  const degrees = Math.floor(absolute);
  const minutesNotTruncated = (absolute - degrees) * 60;
  const minutes = Math.floor(minutesNotTruncated);
  const seconds = Math.floor((minutesNotTruncated - minutes) * 60);

  return `${degrees}°${minutes}'${seconds}''`;
};

const convertDMS = (lat, lng) => {
  const latitude = toDegreesMinutesAndSeconds(lat);
  const latitudeCardinal = Math.sign(lat) >= 0 ? 'N' : 'S';

  const longitude = toDegreesMinutesAndSeconds(lng);
  const longitudeCardinal = Math.sign(lng) >= 0 ? 'E' : 'W';

  return `${latitude} ${latitudeCardinal}\u00a0\u00a0\u00a0${longitude} ${longitudeCardinal}`;
};

const tileUrl = L.Browser.retina
  ? 'https://tiles.corp.smartdriving.io/v1/map/{z}/{x}/{y}@2x.png'
  : 'https://tiles.corp.smartdriving.io/v1/map/{z}/{x}/{y}.png';

@translate(['messages'], { wait: true })
class Messages extends Component {
  componentWillReceiveProps(nextProps) {
    if (this.props.currentInfoEvent.id !== nextProps.currentInfoEvent.id) {
      $('body').scrollTop(0);
      $(findDOMNode(this)).fadeOut(150);
      $(findDOMNode(this)).fadeIn(150);
    }
  }

  render() {
    const { currentInfoEvent, t } = this.props;

    let show_additional = true;

    if (currentInfoEvent.type > 1003 && currentInfoEvent.type < 1009) {
      show_additional = false;
    }

    const icon = L.divIcon({
      html: `<div class="car-map">
              <i class="car"></i>
              <span class="car-circle"><span><em></em></span><span><em></em></span></span>
              <div class="car-note online-note"><span>заблокирован</span></div>
              <div class="map-point-tooltip">
                <span>ул. Пречистенка, 32</span><p>Обновлено в 14:16, 02.09.2016</p>
              </div>
            </div>`,
    });
    const position = currentInfoEvent.event
      ? [
          currentInfoEvent.event.lat / 10000000,
          currentInfoEvent.event.lon / 10000000,
        ]
      : [0, 0];

    return this.props.currentInfoEvent.id ? (
      <div className="container">
        <div className="article-block">
          <h1>{currentInfoEvent.header}</h1>
          <div className="date">
            {moment(currentInfoEvent.created * 1000).format(
              'DD MMMM YYYY \u00a0\u00a0\u00a0 HH:mm',
            )}
          </div>
          {show_additional && currentInfoEvent.event ? (
            <div className="offline-mode">
              <div className="map-wrap">
                <Map
                  style={{ height: '100%' }}
                  center={position}
                  zoom={14}
                  zoomControl={false}
                  scrollWheelZoom={false}
                  attributionControl={false}
                >
                  <TileLayer detectRetina url={tileUrl} />
                  <Marker icon={icon} position={position} />
                </Map>
              </div>
              <p>{currentInfoEvent.text}</p>
            </div>
          ) : (
            <p>{currentInfoEvent.text}</p>
          )}
          {currentInfoEvent.event &&
            show_additional && (
              <div className="messages-statistics">
                <h3>{t('messages:geo__header')}</h3>
                <div className="row">
                  <div className="title">{t('messages:geo__address')}</div>
                  <div className="holder">
                    {getLocationText(currentInfoEvent.geoData)}
                  </div>
                </div>
                {currentInfoEvent.event && (
                  <div className="row">
                    <div className="title">{t('messages:geo__coords')}</div>
                    <div className="holder">
                      {convertDMS(
                        currentInfoEvent.event.lat / 10000000,
                        currentInfoEvent.event.lon / 10000000,
                      )}
                    </div>
                  </div>
                )}
                <div className="row">
                  <div className="title">{t('messages:geo__time')}</div>
                  <div className="holder">{`${moment(
                    currentInfoEvent.created * 1000,
                  ).format('HH:mm')}\u00a0\u00a0\u00a0${moment(
                    currentInfoEvent.created * 1000,
                  ).format('DD/MM/YYYY')}`}</div>
                </div>
              </div>
            )}
          {currentInfoEvent.event &&
            show_additional && (
              <div className="messages-statistics">
                <h3>{t('messages:car__header')}</h3>
                {/* <div className="row">
                  <div className="title">Режим</div>
                  <div className="holder">Охранный</div>
                </div>*/}
                <div className="row">
                  <div className="title">{t('messages:car__engine')}</div>
                  <div className="holder">
                    {currentInfoEvent.event.ignition
                      ? t('messages:car__engine-on')
                      : t('messages:car__engine-off')}
                  </div>
                </div>
                {/* <div className="row">
                  <div className="title">Центральный замок</div>
                  <div className="holder">Закрыт</div>
                </div>*/}
                {/* <div className="row">
                  <div className="title">Топливный бак</div>
                  <div className="holder">34 л (57%)</div>
                </div>*/}
                {currentInfoEvent.event.voltage !== undefined && (
                  <div className="row">
                    <div className="title">{t('messages:car__battery')}</div>
                    <div className="holder">
                      {voltageToPercents(currentInfoEvent.event.voltage)}%
                    </div>
                  </div>
                )}
                {currentInfoEvent.event.canOdometer !== undefined && (
                  <div className="row">
                    <div className="title">{t('messages:car__distance')}</div>
                    <div className="holder">
                      {Math.round(
                        currentInfoEvent.event.canOdometer / 1000,
                      ).toLocaleString('ru')}
                      {t('messages:km')}
                    </div>
                  </div>
                )}
              </div>
            )}
        </div>
      </div>
    ) : null;
  }
}

Messages.propTypes = {
  currentInfoEvent: PropTypes.object,
};

export default connect(
  state => ({
    currentInfoEvent: state.infoEvents.currentInfoEvent,
  }),
  () => ({}),
)(Messages);



// WEBPACK FOOTER //
// ./src/components/Messages/index.js